import axios from './axiosConfig';
//import { createBrowserHistory } from "history";
//const API_URL = "https://api.demo1.raborisk.ai";
const API_URL = process.env.NODE_ENV === 'production'

  ? "https://api.demo1.raborisk.ai"
  : "http://localhost:3000";




export const getReports = () => {

  return (dispatch) => {
    axios
      .get(`${API_URL}/api/reports/get_reports`)
      .then(({ data }) => {
        ////console.log("Get Reports Data", data)
        dispatch({ type: 'GET_REPORTS_SUCCESS', report: data });
      })
      .catch((error) => {
        dispatch({ type: 'GET_REPORTS_FAILURE', error });
      });
  };
};


export const getReport = (id) => {
  return (dispatch) => {
    axios
      .get(`${API_URL}/api/reports/get_report/${id}`)
      .then(({ data }) => {
        ////console.log("Get Report Data", data)
        dispatch({ type: 'GET_REPORT_SUCCESS', payload: data });
      })
      .catch((error) => {
        dispatch({ type: 'GET_REPORT_FAILURE', error });
      });
  };
};


export const createReport = (title, reportJson, type) => {
  //console.log("Type: ", type)
    return (dispatch) => {
        // Handle both old format (editableName) and new format (blocks)
        let reportTitle = title;
        let reportData = reportJson;
        
        if (reportJson?.blocks) {
            // New format - extract title from hero block if not provided
            if (!reportTitle || reportTitle === 'Report') {
                const heroBlock = reportJson.blocks.find(b => b.type === 'hero');
                if (heroBlock?.content?.title) {
                    reportTitle = heroBlock.content.title;
                }
            }
            // Ensure proper structure
            reportData = {
                blocks: reportJson.blocks,
                metadata: reportJson.metadata || {
                    version: '2.0',
                    createdAt: new Date().toISOString(),
                },
            };
        }
        
        //console.log("Creating report:", { title: reportTitle, type, dataSize: JSON.stringify(reportData).length });
        
        axios.post(API_URL + "/api/reports/create_report", {
            title: reportTitle,
            json: reportData,
            type: type
        }).then(({ data }) => {
            //console.log("Report created successfully:", data);
            dispatch({ type: "CREATE_REPORT_SUCCESS", report: data });
            dispatch(getReports());
        }).catch((error) => {
            console.error("Error creating report:", error);
            console.error("Error response:", error.response?.data);
        });
    };
};

export const deleteReport = (id) => {
    return (dispatch) => {
        axios.delete(API_URL + `/api/reports/delete_report/${id}`)
            .then(({ data }) => {
                dispatch({ type: "REPORT_DELETED", payload: id });
            });
    };
};


export const saveReport = (id, json) => {
    return (dispatch) => {
        // Handle both old format (editableName) and new format (blocks)
        let title = 'Report';
        let data = json;
        
        if (json?.editableName?.title) {
            // Old format
            title = json.editableName.title;
        } else if (json?.blocks) {
            // New format - extract title from hero block if available
            const heroBlock = json.blocks.find(b => b.type === 'hero');
            if (heroBlock?.content?.title) {
                title = heroBlock.content.title;
            }
            // Wrap in proper structure for consistency
            data = {
                blocks: json.blocks,
                metadata: json.metadata || {
                    version: '2.0',
                    updatedAt: new Date().toISOString(),
                },
            };
        }
        
        //console.log("Saving report:", { id, title, dataSize: JSON.stringify(data).length });
        
        axios.put(API_URL + `/api/reports/save_report/${id}`, {
            title: title,
            data: data,  // Backend expects 'data', not 'json'
        }).then(({ data }) => {
            //console.log("Report saved successfully");
            dispatch(getReports());
        }).catch((error) => {
            console.error("Error saving report:", error);
            console.error("Error response:", error.response?.data);
        });
    };
};

export const clearCurrentReport = () => ({
  type: 'CLEAR_CURRENT_REPORT',
});
